<template>
  <div :class="s.wrapper">
    <top-head/>
    <!-- <spacer :y="4"/> -->
    <TopImages id="menu-trigger"/>

    <!-- お知らせ -->
    <SectionContainer :class="s.info" id="bg-trigger">
      <SectionFrame
        :title="'お知らせ'"
        :titleBottomMargin="46"
        :smTitleBottomMargin="21"
        :marginTop="-27"
        :smMarginTop="0"
        :titleSize="32"
        :smTitleSize="32"
        :titleOpacity="80">
        <InfoList :limit="5" />
        <Spacer :y="7"/>
        <FlexList :align="'center'">
          <basic-btn
            :tag="'a'"
            :link="'/news/'">もっと見る</basic-btn>
        </FlexList>
      </SectionFrame>
    </SectionContainer>

    <SectionContainer>
      <SectionFrame
        :marginTop="120"
        :smMarginTop="70">
        <a href="https://www.instagram.com/musubisumu_kiryu/" target="_blank">
          <img class="pc" src="/images/top/banner_event_pc.png" alt="">
          <img class="sp" src="/images/top/banner_event_sp.png" alt="">
        </a>
      </SectionFrame>
    </SectionContainer>

    <Spacer :y="6"/>

    <!-- 桐生を知る -->
    <div :class="s.about">
      <img :class="s.about_arc" :src="`/images/layout/top_arc.svg`" alt="">
      <div :class="s.about_bg">
        <div :class="[s.about_bg_img, s.about_bg_img_1]"></div>
        <div :class="[s.about_bg_img, s.about_bg_img_2]"></div>
        <div :class="[s.about_bg_img, s.about_bg_img_3]"></div>
      </div>
      <div :class="s.about_content">
        <div :class="s.about_title">産地を知る</div>
        <div :class="s.about_detail">
          <p :class="s.about_detail_text">
            <span :class="s.about_detail_text_span">紡ぐ人、撚る人、</span>
            <span :class="s.about_detail_text_span">染める人、整経する人、</span>
            <span :class="s.about_detail_text_span">織る人、刺繍する人、</span>
            <span :class="s.about_detail_text_span">仕立てる人、販売する人</span>
          </p>
          <p :class="s.about_detail_text">
            1300年の歴史が宿る織都に、<br>
            職人たちの技と息づかいが今も集う
          </p>
          <p :class="s.about_detail_text">
            「生み出せないものはない」<br>
            絹から広がり、<br>
            進化を重ねてきたものづくりの気質
          </p>
          <p :class="s.about_detail_text">
            技を受け継ぐ手と、<br>
            新しい風を吹き込む感性が重なり合い、<br>
            今日もまた、<br>
            桐生から世界へ紡ぎ出されていく
          </p>
        </div>
        <router-link to="/about/">
          <basic-btn
            :color="'wht'"
            :width="'fit-content'">詳しく見る</basic-btn>
        </router-link>
      </div>
    </div>
    <div :class="s.about_img_wrap">
        <FlexList
          :class="s.about_img_list"
          v-if="layout.sizeChecked"
          :spaceX="0"
          :spaceY="0"
          :count="5"
          :smCount="3"
          :wrap="true">
          <li v-for="(img, i) in aboutImages" :key="i">
            <div
              :class="s.about_img"
              :style="`background-image: url('${$mediaUrl(img)}');`"/>
          </li>
        </FlexList>
      </div>

    <Spacer :y="30" :smY="18"/>

    <SectionContainer v-if="pickups.length">
      <SectionFrame
        :title="'メニュー'"
        :maxWidth="1080"
        :marginTop="0"
        :smMarginTop="0"
        :titleOpacity="80"
        :titleBottomMargin="48">
        <FlexList
          :spaceX="24"
          :spaceY="64"
          :smSpaceY="32"
          :count="3"
          :smCount="1"
          :wrap="true"
          :align="pickups.length < 4 ? 'center' : 'left'"
          :class="[s.pickup, s.links]">
          <li v-for="(item, i) in pickups" :key="i">
            <a
              :href="item.link"
              :target="'_blank'">
              <ContentCard
                :img="item.medias.length ? item.medias[0].url : ''"
                :imgBorderRadius="28"
                :contentSidePadding="0"
                :title="item.title"
                :content="item.summary"></ContentCard>
            </a>
          </li>
        </FlexList>
      </SectionFrame>
    </SectionContainer>

    <Spacer :y="20" :smY="15"/>

    <Interview :category="categoryId"/>

    <Spacer :y="20" :smY="15"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  BasicBtn,
  Spacer,
  SectionFrame,
  SectionContainer,
  TopImages,
  InfoList,
  FlexList,
  ContentCard,
  Interview,
} from '@/components/parts';
import TopHead from '@/components/layouts/TopHead.vue';

export default {
  components: {
    TopHead,
    BasicBtn,
    Spacer,
    SectionFrame,
    SectionContainer,
    TopImages,
    InfoList,
    FlexList,
    ContentCard,
    Interview,
  },
  data() {
    return {
      isSpView: false,
      akiyaUrls: {
        local: 'http://localhost:4088/',
        develop: 'https://dev.kiryu-akiya.jp',
        production: 'https://kiryu-akiya.jp',
      },
      aboutImages: [
        '/images/top/top_about_1.jpg',
        '/images/top/top_about_2.jpg',
        '/images/top/top_about_3.jpg',
        '/images/top/top_about_4.jpg',
        '/images/top/top_about_5.jpg',
      ],
      links: [
        {
          name: 'working',
          label: '働く',
          description: '店舗開業・起業、テレワークから就農まで、スタイルに合わせた多様な働く場所や仕事探しに関する情報を紹介します。',
          path: '/hataraku/',
          img: '/images/top/working.jpg',
        },
        {
          name: 'living',
          label: '住む',
          description: 'まちなかと自然が近く、両方の良いとこどりができる桐生市では、アクセスが良い駅近の物件から、緑に囲まれた一戸建ての物件まで、希望に合わせて選ぶことができます。ここでは物件探しや支援制度に関する情報をまとめています。',
          path: '/sumu/',
          img: '/images/top/living.jpg',
        },
        {
          name: 'raising',
          label: '育てる',
          description: '子育てに関する支援や、桐生ならではの教育プログラム、新たな学びの場からお出かけスポットまで、子育てに関する情報を紹介します。',
          path: '/kosodate/',
          img: '/images/top/raising.png',
        },
      ],
      pickups: [],
    };
  },
  computed: {
    ...mapState(['user', 'layout', 'helper']),
    akiyaLink() {
      const env = this.helper.env.name || 'production';
      return this.akiyaUrls[env];
    },
    categoryId() {
      return this.helper?.categories?.find((d) => d.name === 'tex-top')?.id || null;
    },
  },
  created() {
    this.getPickups();
  },
  methods: {
    getPickups() {
      const params = {
        flags: [1],
        orderBy: 'order',
        order: 'asc',
        frontend_type: 21,
      };

      this.axios({
        method: 'GET',
        url: '/v1/pickup/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.pickups = res.pickups.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrapper {
  width: 100%;
  overflow: hidden;
  min-height: 300px;
}
.info {
  position: relative;
  z-index: 1;
  margin-top: -14px;
}

.about {
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-block: 200px 100px;
  
  &_arc {
    position: absolute;
    top: 0;
    z-index: 1;
    width: calc(100% * 1558 / 1440);
  }
  &_bg {
    position: absolute;
    inset: 0;
    z-index: 0;

    &_img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: right;
      opacity: 0;
      animation: aboutBgFade 15s infinite;

      &_1 {
        background-image: url('/images/top/about_bg_1.jpg');
        animation-delay: 0s;
        opacity: 1;
        background-position-y: 20px;
      }

      &_2 {
        background-image: url('/images/top/about_bg_2.jpg');
        animation-delay: 5s;
        background-position-y: 0px;
      }

      &_3 {
        background-image: url('/images/top/about_bg_3.jpg');
        animation-delay: 10s;
        background-position-y: 10px;
      }
    }
  }
  &_content {
    width: calc(50% - 40px);
    max-width: 680px;
    // align-self: flex-start;
    // transform: translate(10vw, 0);
    left: 0;
    display: flex;
    flex-flow: column;
    align-items: center;
    color: #ffffff;
    text-align: center;
    padding: 4%;
    position: relative;
    z-index: 1;
    // background-color: rgb(0 0 0 /0.3);
    border-radius: 28px;
  }
  &_title {
    font-weight: 700;
    font-size: 48px;
    text-shadow: 0px 4px 20px #000000;
  }
    &_detail {
      font-size: 20px;
      line-height: 1.8;
      margin-bottom: 60px;
      font-family: 'Noto Sans JP';
      font-weight: 500;
      text-shadow: 0px 4px 20px #000000;

      &_text {
        margin: 0;
        margin-top: 24px;
      }

      &_text_span {
        display: inline-block;
        white-space: nowrap;
      }
    }
  &_img {
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-position: center;
    &_wrap {
      width: 100%;
    }
  }

  @include mdView {
    padding-block: 180px 80px;

    &_content {
      width: 560px;
    }

    &_title {
      font-size: 32px;
    }

    &_detail {
      font-size: 18px;
      margin-bottom: 50px;

      &_text {
        margin-top: 20px;
      }
    }
  }

  @include smView {
    padding-block: 150px 50px;
    &_content {
      padding-bottom: 20px;
      width: 80%;
      max-width: 460px;
    }

    &_title {
      margin-top: 0;
      font-size: 23px;
    }

    &_detail {
      font-size: 15px;
      line-height: 1.5;
      margin-bottom: 30px;
    }

    &_bg_img {

      &_1 {
        background-position: 80% 18%;
      }

      &_2 {
        background-position: 80%  0%;
      }
      
      &_3 {
        background-position: 80% 20%;
      }
    }

    &_img_list {
      justify-content: center;
    }
  }
}

@keyframes aboutBgFade {
  0% {
    opacity: 0;
  }
  7% {
    opacity: 1;
  }
  33% {
    opacity: 1;
  }
  40% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.flexbox {
  display: flex;
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  justify-content: space-between;

  &.sm_reverse {
    flex-direction: row-reverse;
  }

  &_content {
    width: calc(50% - 24px);
  }

  &_imgs {
    display: flex;
    justify-content: space-between;
    .img {
      background-size: cover;
      background-position: center;
    }
    &.horizontal {
      .img {
        width: calc(50% - 4px);
        height: 100%;
      }
    }
    &.vertical {
      flex-flow: column;
      .img {
        height: calc(50% - 4px);
        width: 100%;
      }
    }
  }
  &_text {
    &_wrap {
      width: 50%;
    }
    padding: 108px 133px;
    display: flex;
    flex-flow: column;
    align-items: center;
    &_detail {
      text-align: center;
      line-height: 2;
      font-size: 22px;
      font-weight: 500;
    }
  }

  @include smView {
    display: block;

    &_content {
      width: 100%;
    }

    &_text {
      padding: 34px 67px;

      &_detail {
        font-size: 18px;
      }
    }

    &_imgs {
      padding-bottom: 8px;
      .img {
        padding-top: 200px;
      }
      &.vertical {
        flex-flow: inherit;
        .img {
          width: calc(50% - 4px);
        }
      }
    }
  }
}

.akiya {
  border-radius: 28px;
  padding: 42px 0;
  text-align: center;
  color: #ffffff;
  font-weight: 700;
  font-size: 26px;
  background-size: cover;
  background-position: center;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    right: 24px;
    top: 50%;
    width: 28px;
    height: 28px;
    transform: translate(0, -50%);
    border-radius: 50%;
    background-color: #ffffff;
  }
  &::after {
    content: '';
    position: absolute;
    right: 34px;
    top: 50%;
    width: 10px;
    height: 10px;
    transform: translate(0, -50%) rotate(-45deg);
    border-right: 2px solid #000000;
    border-bottom: 2px solid #000000;
  }

  @include smView {
    font-size: 18px;
  }
}

.pickup {
  > li {
    width: 25%;
  }
}

.banners {
  padding: 80px 64px;
  .banner {
    width: 100%;
    padding-top: calc(100% * (144 / 420));
  }
}

.links {
  &_img {
    padding: 124px 0;
    text-align: center;
    border-radius: 28px;
    color: #ffffff;
    font-weight: 700;
    font-size: 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transition: all .3s;
  }
  &_content {
    font-weight: 500;
    margin-top: 16px;
    color: var(--label-primary);
  }
  a {
    transition: all .3s;
    &:hover {
      opacity: .6;
    }
  }
}
</style>
